/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of content in search results
 */
export enum ContentType {

    Article = 'article',

    Faq = 'faq',

    Video = 'video',

    Shortcut = 'shortcut'
}
